<div class="twc-d-flex" style="justify-content: space-between;">
    <span>{{'LAYER_SELECT.CREATE_NEW' | translate}}</span>
    <twc-icon class="new-layer-close-icon" shape="close" (click)="onClose()"
        qaid="new-layer_create-layer-close"></twc-icon>
</div>
<form [formGroup]="uploadWizardService.layerForm">
    <div class="twc-form" qaid="new-layer_form-layer-data">
        <div class="twc-form-element">
            <label class="twc-form-label twc-body-bold">
                <b>{{'UPLOAD.FIELD_NAME' | translate}}</b>
            </label>
            <div class="twc-form-element"
                [ngClass]="{'twc-invalid': this.uploadWizardService.layerForm.get('name')?.errors}">
                <input class="twc-input width-100" name="name" formControlName="name" qaid="new-layer_form-input-name"
                    [maxlength]="uploadWizardService.nameProjectMaxLength">
            </div>
            <div class="twc-mt-2">
                <div class="twc-form-error twc-d-block" qaid="new-layer_form-input-name_error"
                    *ngIf="this.uploadWizardService.layerForm.get('name')?.hasError('required')">
                    {{'UPLOAD.NAME_REQUIRED' | translate}}
                </div>
            </div>
        </div>

        <div class="twc-form-element twc-mt-3">
            <label class="twc-form-label twc-body-bold">
                <b>{{'UPLOAD.FIELD_DESCRIPTION' | translate}}</b>
            </label>
            <input class="twc-input width-100" name="description" qaid="new-layer_form-input-description"
                formControlName="description">
        </div>

        <div class="twc-form-element twc-mt-3 twc-mb-3">
            <twc-checkbox>
                <input twcCheckboxInput type="checkbox" formControlName="hasProject">
                <label twcCheckboxLabel>{{'UPLOAD.CREATE_PROJECT' | translate}}</label>
            </twc-checkbox>
        </div>

        <div *ngIf="this.uploadWizardService.layerForm.get('hasProject')?.value">
            <div class="twc-form-element twc-mt-3">
                <label class="twc-form-label twc-body-bold">
                    <b>{{'UPLOAD.FIELD_NAME' | translate}}</b>
                </label>
                <div class="twc-form-element"
                    [ngClass]="{'twc-invalid': this.uploadWizardService.layerForm.get('name')?.errors}">
                    <input class="twc-input width-100" name="projectName" formControlName="projectName"
                        qaid="new-layer_form-input-projectname" [maxlength]="uploadWizardService.nameProjectMaxLength">
                </div>
                <div class="twc-mt-2">
                    <div class="twc-form-error twc-d-block"
                        *ngIf="this.uploadWizardService.layerForm.get('projectName')?.hasError('required')">
                        {{'UPLOAD.NAME_REQUIRED' | translate}}
                    </div>
                </div>
            </div>

            <div class="twc-form-element twc-mt-3">
                <div class="twc-form-element">
                    <label class="twc-form-label twc-body-bold">
                        <b>{{'UPLOAD.FIELD_DESCRIPTION' | translate}}</b>
                    </label>
                    <input class="twc-input width-100" name="projectDescription" formControlName="projectDescription"
                        qaid="new-layer_form-input-projectdescription">
                </div>
            </div>

            <div class="twc-form-element twc-mt-3">
                <div class="twc-form-element">
                    <label class="twc-form-label twc-body-bold">
                        <b>{{'UPLOAD.FIELD_CAPTURE_DATE' | translate}}</b>
                    </label>
                    <twc-date-picker [maxDate]="today">
                        <input twcInputDate class="twc-input width-100" name="projectCaptureDate"
                            formControlName="projectCaptureDate" qaid="new-layer_form-input-projectcapturedate">
                    </twc-date-picker>
                </div>
            </div>
        </div>
    </div>
</form>